export default __webpack_public_path__ + "static/media/hht1_ep16_minisitcom_01.2c17a673.png";